import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/button-system.css';
import './styles/rich-text.css';
import './styles/csp-wave1.css';
import './App.css';
import './pages/Dashboard.css';

import Navbar from './components/Navbar';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import LogoutCallback from './pages/LogoutCallback';
import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import Purchases from './pages/Purchases';
import PurchaseDetail from './pages/PurchaseDetail';
import Suppliers from './pages/Suppliers';
import Opportunities from './pages/Opportunities';
import OpportunityDetail from './pages/OpportunityDetail';
import Approvals from './pages/Approvals';
import Users from './pages/Users';
import Groups from './pages/Groups';
import Workflows from './pages/Workflows';
import Reports from './pages/Reports';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ProjectsDashboard from './pages/ProjectsDashboard';
import ProjectsComprasEPage from './pages/projects/ProjectsComprasEPage';
import ProjectsCostManagement from './pages/ProjectsCostManagement';
import Profile from './pages/Profile';
import Holidays from './pages/Holidays';
import TicketExport from './pages/TicketExport';
import TicketAttachmentsWithoutS3 from './pages/TicketAttachmentsWithoutS3';
import PurchaseExport from './pages/PurchaseExport';
import Changes from './pages/changes/ChangesPage';
import ChangeDetail from './pages/changes/ChangeDetailPage';
import ChangeCatalogsHub from './pages/changes/ChangeCatalogsHubPage';
import ChangeCategories from './pages/changes/ChangeCategoriesPage';
import ChangeRequesterAreas from './pages/changes/ChangeRequesterAreasPage';
import ChangeWorkGroups from './pages/changes/ChangeWorkGroupsPage';
import ChangesCalendar from './pages/ChangesCalendar';
import ChangeCabPage from './pages/changes/ChangeCabPage';
import ChangeCabDeckEditorPage from './pages/changes/ChangeCabDeckEditorPage';
import ChangeSecurityAuditPage from './pages/changes/ChangeSecurityAuditPage';
import ChangesDashboard from './pages/ChangesDashboard';
import KnowledgeBase from './pages/KnowledgeBase';
import KnowledgeArticleDetail from './pages/KnowledgeArticleDetail';
import KnowledgeArticleEdit from './pages/KnowledgeArticleEdit';
import KnowledgeArticleImport from './pages/KnowledgeArticleImport';
import DocumentTypes from './pages/DocumentTypes';
import Documents from './pages/Documents';
import DocumentEdit from './pages/DocumentEdit';
import DocumentTypeFields from './pages/DocumentTypeFields';
import Feedbacks from './pages/Feedbacks';
import AdminFeedbacks from './pages/AdminFeedbacks';
import ServiceNowLegacyExplorer from './pages/ServiceNowLegacyExplorer';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AreaProvider } from './context/AreaContext';
import AreaRouteSync from './components/AreaRouteSync';
import { ModalProvider } from './context/ModalContext';
import { FeedbackProvider } from './context/FeedbackContext';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AreaProvider>
          <ModalProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
          <FeedbackProvider>
          <AreaRouteSync />
          <div className="App">
            <Navbar />
            <Container fluid className="app-content">
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/logout/callback" element={<LogoutCallback />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <PrivateRoute>
                    <ProjectsDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/projects/compras-e"
                element={
                  <PrivateRoute>
                    <ProjectsComprasEPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/projects/costs/*"
                element={
                  <PrivateRoute>
                    <ProjectsCostManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tickets"
                element={
                  <PrivateRoute>
                    <Tickets />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tickets/:id"
                element={
                  <PrivateRoute>
                    <TicketDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchases"
                element={
                  <PrivateRoute>
                    <Purchases />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchases/opportunities"
                element={
                  <PrivateRoute requirePurchaseTabsAccess>
                    <Opportunities />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchases/opportunities/:id"
                element={
                  <PrivateRoute requirePurchaseTabsAccess>
                    <OpportunityDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchases/:id"
                element={
                  <PrivateRoute>
                    <PurchaseDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/suppliers"
                element={
                  <PrivateRoute>
                    <Suppliers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/approvals"
                element={
                  <PrivateRoute>
                    <Approvals />
                  </PrivateRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <PrivateRoute allowedRoles={['admin']}>
                    <Users />
                  </PrivateRoute>
                }
              />
              <Route
                path="/groups"
                element={
                  <PrivateRoute>
                    <Groups />
                  </PrivateRoute>
                }
              />
              <Route
                path="/workflows"
                element={
                  <PrivateRoute>
                    <Workflows />
                  </PrivateRoute>
                }
              />
              <Route
                path="/holidays"
                element={
                  <PrivateRoute>
                    <Holidays />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute>
                    <Reports />
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports/dashboard"
                element={
                  <PrivateRoute>
                    <AnalyticsDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ticket-export"
                element={
                  <PrivateRoute>
                    <TicketExport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/tickets-attachments-without-s3"
                element={
                  <PrivateRoute>
                    <TicketAttachmentsWithoutS3 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/purchase-export"
                element={
                  <PrivateRoute>
                    <PurchaseExport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes"
                element={
                  <PrivateRoute>
                    <Changes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/cadastros"
                element={
                  <PrivateRoute>
                    <ChangeCatalogsHub />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/cadastros/:tab"
                element={
                  <PrivateRoute>
                    <ChangeCatalogsHub />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/areas"
                element={
                  <PrivateRoute>
                    <ChangeWorkGroups />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/calendar"
                element={
                  <PrivateRoute>
                    <ChangesCalendar />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/auditoria"
                element={
                  <PrivateRoute>
                    <ChangeSecurityAuditPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/cab/:meetingId"
                element={
                  <PrivateRoute>
                    <ChangeCabPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/cab-deck/global"
                element={
                  <PrivateRoute>
                    <ChangeCabDeckEditorPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/:id/apresentacao"
                element={
                  <PrivateRoute>
                    <ChangeCabDeckEditorPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/dashboard"
                element={
                  <PrivateRoute>
                    <ChangesDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/categories"
                element={
                  <PrivateRoute>
                    <ChangeCategories />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/requester-areas"
                element={
                  <PrivateRoute>
                    <ChangeRequesterAreas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/changes/:id"
                element={
                  <PrivateRoute>
                    <ChangeDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/knowledge-base"
                element={
                  <PrivateRoute>
                    <KnowledgeBase />
                  </PrivateRoute>
                }
              />
              <Route
                path="/knowledge-base/new"
                element={
                  <PrivateRoute>
                    <KnowledgeArticleEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/knowledge-base/import"
                element={
                  <PrivateRoute>
                    <KnowledgeArticleImport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/knowledge-base/:id"
                element={
                  <PrivateRoute>
                    <KnowledgeArticleDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path="/knowledge-base/:id/edit"
                element={
                  <PrivateRoute>
                    <KnowledgeArticleEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/documents"
                element={
                  <PrivateRoute>
                    <Documents />
                  </PrivateRoute>
                }
              />
              <Route
                path="/documents/:id/edit"
                element={
                  <PrivateRoute>
                    <DocumentEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/document-types"
                element={
                  <PrivateRoute>
                    <DocumentTypes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/documents/types/:id/fields"
                element={
                  <PrivateRoute>
                    <DocumentTypeFields />
                  </PrivateRoute>
                }
              />
              <Route
                path="/feedbacks"
                element={
                  <PrivateRoute>
                    <Feedbacks />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/feedbacks"
                element={
                  <AdminRoute>
                    <AdminFeedbacks />
                  </AdminRoute>
                }
              />
              <Route
                path="/config/servicenow-legado"
                element={
                  <PrivateRoute allowedRoles={['admin', 'gerente', 'analista']}>
                    <ServiceNowLegacyExplorer />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Container>
          </div>
          </FeedbackProvider>
        </Router>
          </ModalProvider>
        </AreaProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;

